// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionDetail, PermissionDetailSchema } from 'api/gen/PermissionDetail';

const requiredPart = t.interface({
  content: t.union([t.array(PermissionDetailSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelPermissionDetailSchema = excess(requiredPart);

export interface PagedModelPermissionDetail extends t.TypeOf<typeof PagedModelPermissionDetailSchema> {}
